/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ListItem } from '@trdk/style/List';
import Skeleton from 'react-loading-skeleton';
import {
  Typography, withStyles, Tabs, Tab, TextField,
  Button, TablePagination, Hidden, Grid, List, Divider,
} from '@material-ui/core';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemText from '@material-ui/core/ListItemText';
import clsx from 'clsx';
import NotificationBar from '@trdk/style/NotificationBar';
import AddParty from '../../../components/add-party';
import Dialog from '../../../components/dialog';
import {
  putParty, fetchParties,
  postActivateParty, postRemoveParty,
} from '../../../services/admin/party-service';
import { doFetch, fetchClear } from '../../../services/fetch/fetch.actions';
import { fetchRole } from '../../../services/politician/profile-service';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTable: 0,
      search: '',
      open: false,
      currentPage: 0,
      currentRowPerPage: 10,
      addParty: {},
      openActivate: [],
      openRemove: [],
    };
  }

  componentDidMount() {
    const {
      parties: { fetched, fetching, error }, dispatch,
      me: { fetched: meFetched, fetching: meFetching },
    } = this.props;
    if (!fetched && !fetching) {
      dispatch(this.loadParties());
    }
    if (!meFetched && !meFetching) {
      dispatch(doFetch(
        'ME',
        fetchRole()
          .then((res) => {
            if (!res.ok) {
              throw res.statusText;
            }
            return res.json();
          }),
      ));
    }
    dispatch(fetchClear('ADD_PARTY'));
    dispatch(fetchClear('ACTIVATE_PARTY'));
    if (error === 'Forbidden' || error === 'Unauthorized') {
      window.location = `${window.location.origin}/#/no-access`;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  loadParties = () => (dispatch) => {
    dispatch(doFetch(
      'PARTIES',
      fetchParties()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 403) {
              window.location = `${window.location.origin}/#/no-access`;
            }
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  fetchaddPartyfunction = (name) => {
    const { addParty } = this.state;
    const { dispatch } = this.props;

    putParty({
      name: name.toLowerCase(),
      display: name,
      active: true,
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        this.setState({ addParty: { ...addParty, [name]: 'success' } });
        dispatch(fetchClear('PARTIES'));
        dispatch(fetchClear('PARTIES_NAME'));
        dispatch(this.loadParties());
      }).catch(() => this.setState({ addParty: { ...addParty, [name]: 'error' } }));

    this.setState({ open: false });
  }

  activateParty = (id) => {
    const { dispatch } = this.props;
    dispatch(doFetch(
      'ACTIVATE_PARTY',
      postActivateParty(id, true)
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res;
        }).then((r) => {
          dispatch(fetchClear('PARTIES'));
          dispatch(this.loadParties());
          return r;
        }),
    ));
  }

  removeParty = (id) => {
    const { dispatch } = this.props;
    postRemoveParty(id)
      .then((res) => {
        if (!res.ok) { throw res.statusText; }
        this.setState({ });
        dispatch(fetchClear('PARTIES'));
        dispatch(this.loadParties());
        return res;
      });
  }

  render() {
    const {
      classes,
      history,
      parties: {
        payload: { Resources: data },
        fetching,
        fetched,
        error: fetchError,
      },
      me: { payload: me, fetched: meFetched },
    } = this.props;
    const {
      selectedTable, search, open, currentPage,
      currentRowPerPage, addParty, openActivate, openRemove,
    } = this.state;

    const min = currentPage * currentRowPerPage;
    const max = min + currentRowPerPage - 1;

    const filtered = data != null ? data
      .filter(item => (`${item.display.toLowerCase()}`)
        .includes(search.toLowerCase()) || search === '') : [];

    const options = [5, 10, 25, 100];
    let paginated = [];
    if (fetched && !fetchError) {
      paginated = filtered.filter(item => (
        item.active ? selectedTable === 0 : selectedTable === 1
      ));
    }
    const list = paginated.filter((item, i) => i <= max && i >= min);

    return (
      <div className={classes.root}>
        <Typography variant="h4" className={classes.mb} color="primary">Partier</Typography>
        <div className={classes.flex}>
          <TextField className={classes.search} label="Søk etter parti" margin="dense" value={search} onChange={e => this.setState({ search: e.target.value, currentPage: 0 })} />
          <Button variant="outlined" color="primary" onClick={() => this.setState({ open: true })} className={classes.button}>
            + Registrer nytt parti
          </Button>
        </div>
        <Tabs
          className={classes.tabs}
          value={selectedTable}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, value) => {
            this.setState({ selectedTable: value });
          }}
        >
          <Tab label="Aktiverte" className={classes.tab} />
          <Tab label="Deaktiverte" className={classes.tab} />
        </Tabs>
        <AddParty
          open={open}
          handleCancel={() => this.setState({ open: false })}
          handleAccept={(name) => {
            this.fetchaddPartyfunction(name);
          }}
          onEnter={() => this.setState({ addParty: {} })}
        />
        {!fetchError ? (
          <div>
            <List key={1} component="nav" disablePadding>
              <Divider />
              {list.length > 0 && list
                .map(({
                  name, id, members, active, display,
                }, i) => (
                  <div key={`id-${id}`}>
                    {active ? (
                      <MuiListItem key={id} className={clsx(i % 2 !== 0 && classes.odd, classes.listitem)} divider button onClick={() => { history.push(`/admin/partier/${id}`); }}>
                        <MuiListItemText
                          primary={`${display || name}`}
                          secondary={`Antall medlemmer: ${members != null ? members.length : '0'}`}
                          className={classes.muilistitemtext}
                        />
                      </MuiListItem>
                    ) : [
                      <MuiListItem key={`${id}-2`} className={clsx(i % 2 !== 0 && classes.odd, classes.listitemDeactive)} divider>
                        <MuiListItemText
                          primary={`${display || name}`}
                          key={4}
                          secondary={`Antall medlemmer: ${members != null ? members.length : '0'}`}
                          className={classes.muilistitemtext}
                        />
                        <Button
                          key={5}
                          variant="contained"
                          color="secondary"
                          className={classes.activate}
                          onClick={() => this.setState({
                            openActivate: { ...openActivate, [id]: true },
                          })}
                        >
                          Aktiver
                        </Button>
                      </MuiListItem>,
                      <Dialog
                        key="Aktiver parti"
                        title="Aktiver parti"
                        text={`Ønsker du å aktivere ${display || name} på nytt?`}
                        open={!!openActivate[id]}
                        handleClose={() => this.setState({
                          openActivate: { ...openActivate, [id]: false },
                        })}
                        handleAccept={() => this.activateParty(id)}
                        agreeButton="Aktiver"
                        removeText={meFetched && me.roles.includes('superadmin') ? 'Fjern parti' : ''}
                        removeClick={() => this.setState({
                          openActivate: { ...openActivate, [id]: false },
                          openRemove: { ...openRemove, [id]: true },
                        })}
                      />,
                      <Dialog
                        key="Fjern parti"
                        title="Fjern parti"
                        text={`Er du sikker på at du vil fjerne ${display || name} for godt? Historikken til partiet vil da også bli fjernet.`}
                        open={!!openRemove[id]}
                        handleClose={() => this.setState({
                          openRemove: { ...openRemove, [id]: false },
                        })}
                        handleAccept={() => this.removeParty(id)}
                        agreeButton="Fjern"
                      />,
                    ]}
                  </div>
                ))}
              {fetching && Object.keys(Array(5).fill(0))
                .map(val => (
                  <ListItem
                    key={`skel-${val}`}
                    primary={<Skeleton />}
                    secondary={<Skeleton />}
                  />
                ))
              }
              {!fetching && list.length === 0 && (
                <MuiListItem divider>
                  <MuiListItemText
                    primary="Ingen partier i listen"
                    secondary="Prøv å søk noe annet eller se annen liste"
                  />
                </MuiListItem>
              )}
            </List>
            {!fetching && list.length > 0 && [
              <Hidden xsDown key="hiddenxs">
                <TablePagination
                  component="nav"
                  page={currentPage}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
                  labelRowsPerPage="Partier per side"
                  rowsPerPage={currentRowPerPage}
                  rowsPerPageOptions={options}
                  count={filtered.filter(item => (
                    item.active ? selectedTable === 0 : selectedTable === 1
                  )).length}
                  onChangePage={(e, page) => this.setState({ currentPage: page })}
                  onChangeRowsPerPage={e => this.setState({ currentRowPerPage: e.target.value, currentPage: 0 })}
                />
              </Hidden>,
              <Hidden smUp key="hiddensm">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.showingtext}>
                      {`Viser side ${currentPage + 1} av ${Math.ceil(filtered.filter(item => (
                        item.active ? selectedTable === 0 : selectedTable === 1
                      )).length / currentRowPerPage)}`}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => this.setState({ currentPage: currentPage - 1 })}
                      disabled={currentPage === 0}
                      fullWidth
                    >
                      Forrige side
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      disabled={(currentPage + 1) >= (filtered.filter(item => (
                        item.active ? selectedTable === 0 : selectedTable === 1
                      )).length) / currentRowPerPage}
                      onClick={() => this.setState({ currentPage: currentPage + 1 })}
                    >
                      Neste side
                    </Button>
                  </Grid>
                </Grid>
              </Hidden>,
            ]}
          </div>
        ) : (
          <NotificationBar message="Feil ved henting av partiene" variant="error" />
        )}
        {Object.values(addParty).includes('error') && <NotificationBar message="Feil ved oppretting av parti" variant="error" />}
      </div>
    );
  }
}

Overview.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  parties: PropTypes.any.isRequired,
  me: PropTypes.any.isRequired,
};

const styles = theme => ({
  mb: {
    marginBottom: '0.5rem',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'bottom',
    marginBottom: '1rem',
    flexWrap: 'wrap-reverse',
  },
  button: {
    minWidth: '13rem',
    marginTop: '8px', // same as Material Ui TextField
    marginBottom: '4px', // same as Material UI TextField
  },
  search: {
    minWidth: '17rem',
  },
  root: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  tabs: {
    minHeight: '2rem',
  },
  tab: {
    maxHeight: '3rem',
    minHeight: 0,
  },
  muilistitemtext: {
    padding: 0,
  },
  odd: {
    backgroundColor: '#f7f7f7',
  },
  listitem: {
    '&:hover, &:focus': {
      borderLeft: `0.2rem solid ${theme.palette.primary.main}`,
    },
    borderLeft: '0.2rem solid transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6rem',
    },
  },
  listitemDeactive: {
    borderLeft: '0.2rem solid transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6rem',
    },
  },
  showingtext: {
    color: '#808080',
    marginTop: '1rem',
  },
  activate: {
    '&:hover': {
      backgroundColor: '#00953b',
      color: '#fff',
    },
  },
});

const mapStateToProps = ({ parties, me }) => ({ parties, me });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(Overview)));
